module.exports = " <div class=new-real-footer> <br/> <strong style=padding:20px;font-family:Calibri>다영이 DaYoung English Institute KR</strong> <span style=font-size:9px!important> <br/> 서울시 관악구 봉천동 870-13 612호 </span> <br/> <a class=magic-icons href=https://www.facebook.com/dayoungenglish/ ><span class=\"fa fa-facebook-square\"></span></a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ssp-footer/ssp-footer.html
// module id = 482
// module chunks = 0